import { Button } from 'ui/mobile-ds';
import { CrossCircle } from 'ui/icons';
import { get } from 'lodash';
import { twConfig } from 'ui/ds/utils/getConfig';
interface IProps {
  title: string;
  subtitle: string;
  handleCtaClick: () => void;
}

const ChatErrorScreen = ({ title, subtitle, handleCtaClick }: IProps) => {
  return (
    <div className="flex items-center justify-center h-[100%]">
      <div className="flex flex-col items-center justify-center gap-4">
        <CrossCircle
          data-testid="cross-circle-icon"
          fill={get(twConfig, 'theme.colors.primary.600')}
        />
        <div className="flex flex-col items-center gap-2">
          <p className=" text-mobile-text-main font-black text-[22px] font-chromatica text-center">
            {title}
          </p>
          <p className="text-sm md:text-base text-gray-400 flex flex-col md:flex-row gap-1 text-center">
            {subtitle}
          </p>
        </div>
        <Button
          className="px-10 py-[14px] text-base font-body font-medium"
          intent={'primary'}
          onClick={handleCtaClick}
        >
          Retry
        </Button>
      </div>
    </div>
  );
};

export default ChatErrorScreen;
